import { render, staticRenderFns } from "./DemographicsHeightWeight.vue?vue&type=template&id=7b043002&scoped=true"
import script from "./DemographicsHeightWeight.vue?vue&type=script&lang=js"
export * from "./DemographicsHeightWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b043002",
  null
  
)

export default component.exports